import { render, staticRenderFns } from "./InsertPromotion.vue?vue&type=template&id=e7d74c40&scoped=true"
import script from "./InsertPromotion.vue?vue&type=script&lang=js"
export * from "./InsertPromotion.vue?vue&type=script&lang=js"
import style0 from "./InsertPromotion.vue?vue&type=style&index=0&id=e7d74c40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7d74c40",
  null
  
)

export default component.exports